import React from 'react';
import useAppState from '../../AppStore';
import { ToolNames } from '../ToolNames';
import NoLegendMessage from './NoLegendMessage';

interface NoLayerLegendProps {
  topicId: string;
}

const viewSettingName = 'mapContent_tool_topic_settings';

const NoLayerLegend = ({ topicId }: NoLayerLegendProps) => {
  const activeView = useAppState((state) => state.activeView);
  const setActiveTool = useAppState((state) => state.setActiveTool);
  const currentTopicLayerId = useAppState((state) => state.currentTopicLayerId);
  const setCurrentTopicLayerId = useAppState((state) => state.setCurrentTopicLayerId);

  const handleOnClick = () => {
    setCurrentTopicLayerId(topicId);
    setActiveTool(ToolNames.layerSelection, viewSettingName);
  };

  const showButton = currentTopicLayerId === topicId && activeView === viewSettingName;

  return (
    <NoLegendMessage
      textKey="no_legend_layers"
      showButton={showButton}
      handleOnClick={handleOnClick}
    />
  );
};

export default NoLayerLegend;
